import { render } from "./ArtistCardModal.vue?vue&type=template&id=87ad447a"
import script from "./ArtistCardModal.vue?vue&type=script&lang=js"
export * from "./ArtistCardModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ArtistCardModal.vue?vue&type=style&index=0&id=87ad447a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__